import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { getLink } from "../../views/partials/setup-payment";
import loader from "../loader.vue"
import { useUserspace } from "@/store/userspace";
type Emits = {
    (e: "moveToStage", stage:number): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'paymentConfirm',
  emits: ["moveToStage"],
  setup(__props, { expose, emit }: { emit: ({
    (e: "moveToStage", stage:number): void,
}), expose: any, slots: any, attrs: any }) {
  expose();


// const hasAttempted = ref(false);
const loading = ref(false)

const moveToStage = (stage:number) =>{
    emit('moveToStage',stage)
}

async function onClickSubmit() {
    loading.value = true
    try {
        var result = await getLink( useUserspace().uid );
        if(!result) {
            alert("An error occurred while connecting to the server");
            return;
        }
        if(result.data.status === "enabled") {
            alert("Account already setup, try refreshing");
        }

        if(result.data.redirectUrl)
            location.href = result.data.redirectUrl;
    } catch(err: any) {
        console.error(err);
        if(err instanceof Error || "message" in err) {
            alert(err.message);
        } else {
            alert(err);
        }
    }
    loading.value = false;
    // hasAttempted.value = true;
}



const __returned__ = { emit, loading, moveToStage, onClickSubmit, ref, getLink, loader, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})